import React from 'react';
import './customTextProgressBar.scss';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

export const CustomTextProgressbar = (props: any) => {
    const { ...otherProps } = props;
    return (
        <div className="circularbar">
            <div style={{ position: 'absolute' }}>
                <CircularProgressbar
                    {...otherProps} /* eslint-disable-next-line react/jsx-props-no-spreading */
                    className="custom-circular-progressbar"
                    maxValue={otherProps?.total_reported} 
                    styles={buildStyles({
                        textColor: '#2B3A42',
                        pathColor: otherProps?.count < otherProps?.total_reported ? '#64D96E' : '#2AA154',
                        trailColor: 'white',
                    })}
                    value={otherProps?.count} 
                    text={''} 
                    strokeWidth={15}
                />
            </div>
            <div className="circularbar-inner">
                {props.children}
            </div>
        </div>
    );
};